import React from 'react';
import {
  camelotKeyBackground,
  camelotKeyColor,
} from '../../utils/camelotKeyColor';
import './CamelotKeyChip.scss';

export const CamelotKeyChip: React.FC<{
  value?: string;
  className?: string;
}> = ({ value, className }) => {
  const key = value?.trim();
  if (!key) return null;

  return (
    <span
      className={`camelot-key-chip${className ? ` ${className}` : ''}`}
      style={{
        color: camelotKeyColor(key),
        background: camelotKeyBackground(key),
      }}
    >
      {key}
    </span>
  );
};

export default CamelotKeyChip;
